module.exports = __webpack_public_path__ + "img/kantine_2.afd0d8a3.jpg";